import React, { ReactNode } from 'react'

import { Comment } from '@ant-design/compatible'
import moment from 'moment'

import Icon from 'common/components/general/Icon'

import Tooltip from './Tooltip'

interface CommentProps {
  author: string | ReactNode
  avatar: ReactNode
  content: string | ReactNode
  datetime: moment.Moment
  showLikes?: boolean
  likesProps?: LikesProps
}

interface LikesProps {
  numberOfLikes: number
  numberOfDislikes: number
  onLike: () => void
  onDislike: () => void
  action?: 'liked' | 'disliked'
}

const Display = (props: CommentProps) => {
  const likeActions = [
    <span key="like">
      <Tooltip title="Like">
        <Icon type="like" onClick={props.likesProps?.onLike} />
      </Tooltip>
      <span style={{ paddingLeft: 8, cursor: 'auto' }}>{props.likesProps?.numberOfLikes}</span>
    </span>,
    <span key="dislike">
      <Tooltip title="Dislike">
        <Icon type="dislike" onClick={props.likesProps?.onDislike} />
      </Tooltip>
      <span style={{ paddingLeft: 8, cursor: 'auto' }}>{props.likesProps?.numberOfDislikes}</span>
    </span>,
  ]

  return (
    <Comment
      {...props}
      actions={props.showLikes ? likeActions : []}
      datetime={
        <Tooltip title={props.datetime.format('YYYY-MM-DD HH:mm:ss')}>
          <span>{props.datetime.fromNow()}</span>
        </Tooltip>
      }
    />
  )
}

export default Display
